(function() {
	var elSearch = $("[data-search='search']");
	var blockNextChar = false; // true justo después de un Alt + número, para revertir el alt-code si Windows lo inserta

	function update() {
		window.getAllProducts('/products/getProductsA');
		elSearch.focus();
	}
	if(elSearch.length) {
		update();
	}
	$(document).ready(function(e) {
		if(window.searchType !== 'sale') {
			$(".onlysale").remove();
		}

		$(document).on("keydown", function(e) {
			if(!elSearch.length) {
				return;
			}

			// Ignorar el auto-repeat del sistema operativo al mantener la tecla presionada
			if(e.repeat) {
				return;
			}

			var activeEl = document.activeElement;
			var tag = activeEl.tagName.toLowerCase();
			var isEditable = tag === 'input' || tag === 'textarea' || activeEl.isContentEditable;

			// Alt/Option + F5: Actualizar listado de productos
			if(e.altKey && e.code === 'F5') {
				e.preventDefault();
				update();
				return;
			}

			// Esc: Limpiar listado de productos
			if (e.code === 'Escape') {
				e.preventDefault();
				elSearch.val('').trigger('keyup').focus();
				return;
			}

			// Alt/Option + 1..9: Eliminar la fila correspondiente (máximo 9 filas)
			// Se incluye Numpad1-9 porque en Windows, Alt + números del numpad es el atajo
			// clásico para insertar caracteres especiales (alt-codes), y hay que bloquearlo también ahí.
			if (e.altKey && /^(Digit|Numpad)[1-9]$/.test(e.code)) {
				e.preventDefault();
				blockNextChar = true; // por si Windows inserta el alt-code al soltar Alt
				var index = parseInt(e.code.replace('Digit', '').replace('Numpad', ''), 10) - 1;
				$("[data-template-index='"+index+"']").find("[data-index-delete]").click();
				return;
			}

			// Alt/Option + 0: No ejecuta ninguna acción, pero se bloquea igual para evitar
			// que se inserte un carácter especial (alt-code) en un campo editable.
			if (e.altKey && (e.code === 'Digit0' || e.code === 'Numpad0')) {
				e.preventDefault();
				blockNextChar = true;
				return;
			}

			// Backspace: Eliminar la ultima fila
			if (e.code === 'Backspace' && !isEditable) {
				e.preventDefault();
				$("[data-template-index]").last().find("[data-index-delete]").click();
				return;
			}

			// Delete/Supr: Eliminar la ultima fila
			if (e.code === 'Delete' && !isEditable) {
				e.preventDefault();
				$("[data-template-index]").first().find("[data-index-delete]").click();
				return;
			}

			// Alt + Arriba/Abajo: Enfocar piezas de cada fila
			if (e.altKey && (e.code === 'ArrowUp' || e.code === 'ArrowDown')) {
				e.preventDefault();
				var rows = $("[data-template-index]");
				var currentRow = $(activeEl).closest("[data-template-index]");
				var currentIndex = rows.index(currentRow);
				var targetIndex;

				if (currentIndex === -1) {
					targetIndex = e.code === 'ArrowDown' ? 0 : rows.length - 1;
				} else {
					targetIndex = e.code === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
				}

				if (targetIndex >= 0 && targetIndex < rows.length) {
					rows.eq(targetIndex).find('[name="pieces[]"]').trigger('focus').select();
				}
				return;
			}

			// Alt + B: Enfocar buscar
			if (e.altKey && e.code === 'KeyB') {
				e.preventDefault();
				elSearch.trigger('focus');
				return;
			}

			// Alt + G: Registrar
			if(e.altKey && e.code === 'KeyG') {
				e.preventDefault();
				if (isEditable) {
					activeEl.blur();
				}
				var btnRegister = $("[data-call-form]");
				if(!btnRegister.is(':disabled')) {
					btnRegister.click();
				}
				return;
			}

			// Alt + M/V/C/K: Enforcar tipo de pago
			if (window.searchType === 'sale' && e.altKey && ['KeyM', 'KeyV', 'KeyC', 'KeyK'].includes(e.code)) {
				e.preventDefault();
				var paymentByKey = {
					KeyM: '1',
					KeyV: '2',
					KeyC: '3',
					KeyK: '4'
				};
				var value = paymentByKey[e.code];
				$("[name='payment_type']").val(value).trigger('change');
				return;
			}

			// Alt + Q/W/R: Enfocar tipo de descuento
			if (window.searchType === 'sale' && e.altKey && ['KeyQ', 'KeyW', 'KeyR'].includes(e.code)) {
				e.preventDefault();
				var percentageType = {
					KeyQ: '',
					KeyW: 'porcentaje',
					KeyR: 'fijo',
				};
				var value = percentageType[e.code];
				$("[data-discount-type]").val(value).trigger('change');
				return;
			}

			// Alt + H: Enfocar descuento
			if (window.searchType === 'sale' && e.altKey && e.code === 'KeyH') {
				e.preventDefault();
				$("[data-discount-quantity]").trigger('focus');
				return;
			}

			// Alt + Enter: Enforcar pago
			if (window.searchType === 'sale' && e.altKey && e.code === 'Enter') {
				e.preventDefault();
				$("[data-payment]").trigger('focus');
				return;
			}
		});

		// Windows inserta el carácter especial del alt-code como un cambio de valor normal
		// (no como un keydown/keyup interceptable), así que se revierte aquí en cuanto aparece.
		$(document).on('input', 'input, textarea', function(e) {
			if(!elSearch.length) {
				return;
			}
			if (!blockNextChar) {
				return;
			}
			blockNextChar = false;
			var el = this;
			var pos = el.selectionStart;
			var val = $(el).val();
			// Quita el carácter recién insertado en la posición del cursor
			var nuevoVal = val.slice(0, Math.max(0, pos - 1)) + val.slice(pos);
			$(el).val(nuevoVal);
			el.setSelectionRange(Math.max(0, pos - 1), Math.max(0, pos - 1));
		});
	});
})(jQuery);